import React, { useEffect, useState } from 'react';
import API from '../services/api';

function AdminMessagesPage() {
  // Form fields for creating a new message
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [targetTherapistId, setTargetTherapistId] = useState('');

  // The list of messages to display
  const [messages, setMessages] = useState([]);

  // The list of therapists for the dropdown
  const [therapists, setTherapists] = useState([]);

  // For the "older messages" date range
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const fetchMessages = async (params = {}) => {
    try {
      let url = '/admin/messages';
      const queryParts = [];
      if (params.limit) queryParts.push(`limit=${params.limit}`);
      if (params.start) queryParts.push(`start=${params.start}`);
      if (params.end) queryParts.push(`end=${params.end}`);
      if (queryParts.length > 0) {
        url += '?' + queryParts.join('&');
      }
      const res = await API.get(url);
      setMessages(res.data);
    } catch (err) {
      console.error('Error fetching messages:', err);
      alert('Error fetching messages');
    }
  };

  const fetchTherapists = async () => {
    try {
      const res = await API.get('/admin/users');
      const therapistList = res.data.filter(u => u.role === 'THERAPIST');
      setTherapists(therapistList);
    } catch (error) {
      console.error('Error fetching therapists:', error);
      alert('Error fetching therapists');
    }
  };

  useEffect(() => {
    // By default, show only the 3 most recent messages
    fetchMessages({ limit: 3 });
    fetchTherapists();
  }, []);

  const createMessage = async (e) => {
    e.preventDefault();
    try {
      let tid = targetTherapistId;
      if (tid === '') tid = null;

      await API.post('/admin/messages', {
        title,
        content,
        imageUrl,
        targetTherapistId: tid
      });
      alert('Message created!');
      setTitle('');
      setContent('');
      setImageUrl('');
      setTargetTherapistId('');
      fetchMessages({ limit: 3 });
    } catch (err) {
      console.error('Error creating message:', err);
      alert('Error creating message');
    }
  };

  const handleLoadOlder = (e) => {
    e.preventDefault();
    if (!startDate || !endDate) {
      alert('Please enter both start and end dates for older messages.');
      return;
    }
    fetchMessages({ start: startDate, end: endDate });
  };

  return (
    <div>
      <h2>Admin Messages</h2>

      <form onSubmit={createMessage} style={{ marginBottom: '2rem' }}>
        <div>
          <label>Title:</label><br />
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            style={{ width: '300px' }}
          />
        </div>
        <div>
          <label>Content:</label><br />
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            required
            rows={4}
            cols={50}
          />
        </div>
        <div>
          <label>Image URL (optional):</label><br />
          <input
            type="text"
            value={imageUrl}
            onChange={(e) => setImageUrl(e.target.value)}
            style={{ width: '300px' }}
          />
        </div>
        <div>
          <label>Target Therapist:</label><br />
          <select
            value={targetTherapistId}
            onChange={(e) => setTargetTherapistId(e.target.value)}
          >
            <option value="">All Therapists</option>
            {therapists.map(t => (
              <option key={t.id} value={t.id}>
                {t.first_name} {t.last_name}
              </option>
            ))}
          </select>
        </div>

        <button type="submit" style={{ marginTop: '1rem' }}>Post Message</button>
      </form>

      <div style={{ marginBottom: '2rem' }}>
        <h3>Load Older Messages</h3>
        <form onSubmit={handleLoadOlder} style={{ display: 'flex', gap: '1rem' }}>
          <div>
            <label>Start Date:</label><br />
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div>
            <label>End Date:</label><br />
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
          <div style={{ alignSelf: 'flex-end' }}>
            <button type="submit">Load Older</button>
          </div>
        </form>
      </div>

      <h3>Displayed Messages</h3>
      {messages.length === 0 && <p>No messages found.</p>}
      {messages.map(msg => (
        <div
          key={msg.id}
          style={{ border: '1px solid #ccc', padding: '1rem', marginBottom: '1rem' }}
        >
          <h4>{msg.title}</h4>

          {/* Render with HTML support */}
          <p dangerouslySetInnerHTML={{ __html: msg.content }} />

          {msg.image_url && (
            <img
              src={msg.image_url}
              alt="Message"
              style={{ maxWidth: '200px', display: 'block', marginTop: '0.5rem' }}
            />
          )}
          <small>
            By: {msg.creator_first_name} {msg.creator_last_name} on{" "}
            {new Date(msg.created_at).toLocaleString()}
          </small>
          {msg.target_therapist_id ? (
            <p style={{ fontStyle: 'italic', color: '#777' }}>
              Target: Therapist ID {msg.target_therapist_id}
            </p>
          ) : (
            <p style={{ fontStyle: 'italic', color: '#777' }}>Target: All Therapists</p>
          )}
        </div>
      ))}
    </div>
  );
}

export default AdminMessagesPage;
